<template>
    <div class="container">
        <a :href="link" target="_blank" :title="name">
            <img :src="content"/>
            <h3>{{ name }}</h3>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        name: String,
        content: String,
        link: String,
    },
}
</script>

<style lang="less" scoped>
.container {
    height: 120px;
    position: relative;
    overflow: hidden;
    transition: 200ms;
    &:hover {
        transform: translateY(-1px);
    }
}
img {
    object-fit: cover;
    width: 100%;
    height: 100%;
}
</style>